const DEV_MODE = false;
const URL = 'http://demo.planetmedicalsolutions.com';
const IMAGES_URL = 'http://api.planetmedicalsolutions.com';

let _API = `${URL}/server.php/api/fe`;
let _IMAGES_REPO = `${IMAGES_URL}/public`;

if (DEV_MODE) {
  _API = '/api/fe';
  _IMAGES_REPO = 'http://localhost:8000';
}

export const API = _API;
export const IMAGES_REPO = _IMAGES_REPO;



// WEBPACK FOOTER //
// ./src/config.js